import { MijnRoute } from '../../../mijn-navigatie.model';

export const SELF_SERVICE_ECOMMERCE_SUMMARY: MijnRoute = {
    path: 'overzicht',
    navigationEvent: 'toEcommerceSummary',
    regex: /^\/zelf-regelen\/ecommerce\/overzicht$/,
    webcomponent: 'mijn-ecommerce-payments-webcomponent',
    internalPath: 'overzicht'
};
